import { css } from "lit";

export const styles = css`
  .message-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  td.col-title {
    max-width: 250px;
  }

  td.col-title > * {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .col-status {
    width: 110px;
  }

  .col-created {
    width: 110px;
  }

  .col-sent-time {
    width: 60px;
  }

  .col-delivered-count {
    width: 70px;
  }

  .col-opened-count {
    width: 60px;
  }

  .col-clicked-count {
    width: 60px;
  }

  .col-action {
    width: 150px;
  }

  .col-menu {
    width: 32px;
  }

  dropdown-menu {
    --dropdown-trigger-border-radius: var(--sds-size-radius-full);
  }

  /* Message tile (mobile) */
  .mobile-view {
    gap: 0;
  }

  .message-tile {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .message-tile-header {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
  }

  .message-tile-title {
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    flex: 1;
    min-width: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .message-tile-details {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
  }

  .message-tile-details span + span {
    border-left: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    padding-left: var(--sds-size-space-400);
  }

  .message-tile-actions {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
  }

  .message-tile-actions wow-button[full-width] {
    flex: 1;
  }
`;
